
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import { Link } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';

import TableListFooter from 'core/TableListFooter';
import Layout from 'components/Dashboard/Layout';
import { ListContext, ListProvider } from 'core/ListProvider';
import { YellowButton } from 'ui/Button';
import SearchWidget from 'form/SearchWidget';
import ServiceListTable from './ListTable';
import {  SelectButtonGroupWidget } from 'form/SelectButtonGroupWidget';
import { UserContext, hasAccountPermission } from 'components/User';
import { ResponsiveTable } from 'ui/Table';


export default class ServiceList extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Услуги';
  }

  onDetail = (item) => {
    this.props.history.push(`/service/${item.id}`);
  };

  render() {
    return (
      <ListProvider
        url={'catalog/service'}
      >
        <ListContext.Consumer>
          {context => {
            const { items, permissions } = context;
            let addButton = undefined;
            if (hasAccountPermission(this.context, 'catalog.add_service')) {
              addButton = (
                <YellowButton component={Link} to={`/service/add`} startIcon={<AddIcon />}>
                  Добавить услугу
                </YellowButton>
              );
            }

            return (
              <Layout>
                <Layout.Header
                  title={'Услуги'}
                  search={
                    <SearchWidget
                      value={context.filter.q}
                      onChange={(value) => context.setFilterValue('q', value)}
                    />
                  }
                  right={addButton}
                />
                <Layout.Filter>
                  <SelectButtonGroupWidget
                    value={context.filter.type}
                    options={[
                      {value: null, label: 'Все'},
                      {value: 'TARIFF', label: 'Услуги тарифов'},
                      {value: 'ORDER', label: 'Дополнительные услуги'},
                    ]}
                    onChange={(value, option) => context.setFilterValue('type', value)}
                  />
                  <SelectButtonGroupWidget
                    value={context.filter.tariffication}
                    options={[
                      {value: null, label: 'Все'},
                      {value: 'FIXED', label: 'Фиксированная'},
                      {value: 'BY_MILEAGE', label: 'По километражу'},
                    ]}
                    onChange={(value, option) => context.setFilterValue('tariffication', value)}
                  />
                  <SelectButtonGroupWidget
                    value={context.filter.financial_schema}
                    options={[
                      {value: null, label: 'Все'},
                      {value: 'RE_EXPOSED', label: 'Перевыставляемая'},
                      {value: 'OWN', label: 'Собственная'},
                    ]}
                    onChange={(value, option) => context.setFilterValue('financial_schema', value)}
                  />
                  <SelectButtonGroupWidget
                    value={context.filter.is_active}
                    options={[
                      {value: null, label: 'Все'},
                      {value: true, label: 'Активные'},
                      {value: false, label: 'Неактивные'},
                    ]}
                    onChange={(value, option) => context.setFilterValue('is_active', value)}
                  />
                </Layout.Filter>
                <Layout.ContentSimple>
                  <TableContainer component={Paper}>
                    <ResponsiveTable>
                      <ServiceListTable
                        items={items}
                        onDetail={(item) => this.onDetail(item)}
                        hasChangePermission={permissions.change}
                      />
                      <TableListFooter colspan={6} />
                    </ResponsiveTable>
                  </TableContainer>
                </Layout.ContentSimple>
              </Layout>
            )
          }}
        </ListContext.Consumer>
      </ListProvider>
    )
  }
}
